import { Component, inject, Inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MasterService } from "@frontend/app/serivces/master.service";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { SharedModule } from "@frontend/app/shared/shared.module";

@Component({
  selector: "app-order-status",
  imports: [CommonModule, SharedModule],
  templateUrl: "./order-status.component.html",
  styleUrl: "./order-status.component.scss",
})
export class OrderStatusComponent implements OnInit {
  private masterService = inject(MasterService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<OrderStatusComponent>) {}

  ngOnInit() {
    if (this.data.orderId) {
      this.orderID = this.data.orderId;
      this.getOrderDetailsByID(this.orderID);
    }
  }

  //#region variables

  orderDetails: any;
  orderID = 0;
  readonly SVG_ICONS = SVG_ICONS;
  userTypeID = sessionStorage.getItem("UserTypeID");

  //#endregion
  getOrderDetailsByID(orderID: number) {
    this.masterService.getOrderDetailsByID(orderID).subscribe((res: any) => {
      this.orderDetails = res.data;
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  approveOrder() {
    const data = {
      OrderStatus: "Approved",
    };
    this.masterService.updateOrderStatus(data, this.orderID).subscribe((res: any) => {
      if (res.status) {
        this.dialogRef.close(true);
      }
    });
  }

  rejectOrder() {
    const data = {
      OrderStatus: "Rejected",
    };
    this.masterService.updateOrderStatus(data, this.orderID).subscribe((res: any) => {
      if (res.status) {
        this.dialogRef.close(true);
      }
    });
  }

  approveItem(itemId: number) {
    const data = {
      OrderStatus: "Accepted",
    };
    this.masterService.updateOrderItemStatus(data, itemId).subscribe((res: any) => {
      if (res.status) {
        this.getOrderDetailsByID(this.orderID);
      }
    });
  }

  rejectItem(itemId: number) {
    const data = {
      OrderStatus: "Rejected",
    };
    this.masterService.updateOrderItemStatus(data, itemId).subscribe((res: any) => {
      if (res.status) {
        this.getOrderDetailsByID(this.orderID);
      }
    });
  }
}
